import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import UploadFiles from "../upload/uploadFiles";
import IConnectionActions, * as connectionActions from "../../../../redux/actions/connectionActions";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import { IProject, IConnection, IApplicationState } from "../../../../models/applicationState";

export interface ITestProps extends RouteComponentProps, React.Props<Test> {
    project: IProject;
    path: object;
    connections: IConnection;
    actions: IConnectionActions;
    appSecurityTokenAction: IApplicationActions;
    projectActions: IProjectActions;
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
    };
}

export interface ITestState { }

@connect(mapStateToProps)

export default class Test
    extends React.Component<ITestProps, ITestState> {
    public render() {
        return (
            <>
                <UploadFiles
                    project={this.props.project}
                    connections={this.props.connections}
                    actions={this.props.actions}
                    history={this.props.history}
                    location={this.props.location}
                    match={this.props.match}
                    appSecurityTokenAction={this.props.appSecurityTokenAction}
                    projectActions={this.props.projectActions}
                />

 
            </>
        );
    }
}
